import React, { useMemo } from "react";
import useSWR from "swr";
import Button from "../../../Components/Common/Button";
import { useNavigate } from "react-router-dom";
import { publicUrls } from "../../../Api/Auth/AppUrls";
import { staticHomeUrls } from "../../../Api/Auth/ApiUrls";
import { noAuthfetcher } from "../../../Api/swrConfig";

const DEFAULT_CONTENT = {
  title: "Got a question?",
  description:
    "Join us in your FE Exam journey. Connect with us using any of the methods. Our goal is to help you ace your FE Exam.",
  buttonText: "Contact Us",
};

const Contact = ({ data }) => {
  const navigate = useNavigate();
  const shouldFetchHomeContact = !data;

  const { data: homeStaticData } = useSWR(
    shouldFetchHomeContact ? staticHomeUrls.home : null,
    noAuthfetcher
  );

  const homeContactData = useMemo(() => {
    if (!homeStaticData?.data?.content) return {};
    try {
      const parsed = JSON.parse(homeStaticData.data.content);
      const title = parsed?.contactTitle?.trim();
      const description = parsed?.contactDescription;
      const buttonText = parsed?.contactButtonText?.trim();
      return {
        ...(title ? { title } : {}),
        ...(description ? { description } : {}),
        ...(buttonText ? { buttonText } : {}),
      };
    } catch (error) {
      console.warn("Failed to parse home contact content", error);
      return {};
    }
  }, [homeStaticData]);

  const mergedContent = {
    ...DEFAULT_CONTENT,
    ...homeContactData,
    ...(data || {}),
  };

  return (
    <div className="relative sm:mt-24 mt-12 px-4">
      <div className="relative max-w-7xl mx-auto rounded-lg overflow-hidden">
        <div
          className="absolute inset-0 bg-cover md:bg-center bg-left"
          style={{
            backgroundImage:
              'url("https://storage.googleapis.com/road-to-fe/uploads/1741110058763-22a1fe9c-c28a-4db3-bd79-ac6d50fec616-contact.webp")',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80" />

        <div className="relative px-6 sm:px-10 lg:px-14 py-12 sm:py-16 lg:py-20 min-h-[420px] sm:min-h-[500px] flex items-center justify-center md:justify-end">
          <span className="w-full max-w-2xl bg-white/5 backdrop-blur-md rounded-2xl p-6 sm:p-8 space-y-4 sm:space-y-6 text-center md:text-left">
            <h3 className="text-white text-2xl lg:text-3xl font-semibold leading-tight">
              {mergedContent.title}
            </h3>
            <div
              className="text-base sm:text-md text-white/90 space-y-4"
              dangerouslySetInnerHTML={{ __html: mergedContent.description }}
            />
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-center sm:justify-start">
              <Button
                onClick={() => navigate(publicUrls.Contact)}
                className="w-full sm:w-auto justify-center"
              >
                {mergedContent.buttonText}
              </Button>
            </div>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Contact;
